var _rect, _path, _path2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame32(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 475,
    height: 322,
    viewBox: "0 0 475 322",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 475,
    height: 322,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M254.615 169.235L249.268 156.73C248.294 154.44 246.842 153.142 245.185 153.057C243.545 152.971 241.957 154.116 240.744 156.303L237.498 162.128C236.814 163.358 235.841 164.093 234.782 164.178C233.705 164.281 232.629 163.717 231.758 162.606L231.382 162.128C230.169 160.608 228.666 159.873 227.128 160.027C225.591 160.181 224.275 161.24 223.404 162.965L220.449 168.859C219.389 170.994 219.492 173.471 220.739 175.487C221.986 177.503 224.156 178.716 226.53 178.716H248.329C250.618 178.716 252.753 177.571 254.017 175.658C255.316 173.745 255.521 171.336 254.615 169.235Z",
    fill: "#A3A3A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228.907 154.818C232.096 154.818 234.681 152.232 234.681 149.043C234.681 145.854 232.096 143.269 228.907 143.269C225.718 143.269 223.133 145.854 223.133 149.043C223.133 152.232 225.718 154.818 228.907 154.818Z",
    fill: "#A3A3A3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 217.5,
    y: 141,
    width: 40,
    height: 40,
    rx: 5.5,
    stroke: "#A3A3A3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame32);
export default __webpack_public_path__ + "static/media/Frame32.1b1ca7cfa80850c03f3f102adb91a822.svg";
export { ForwardRef as ReactComponent };